import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { I18nProvider } from '../_metronic/i18n/i18nProvider';
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core';
import { MasterInit } from '../_metronic/layout/MasterInit';
import { AuthInit } from './modules/auth';
import { AppProvider, useApp } from './../app/pages/devops/context/AppContext';
import TaskModal from './../app/pages/devops/components/task/TaskModal';

export const MyContext = React.createContext(null);

declare global {
  interface Window {
    gtag: any;
  }
}

function AppContent() {
  const location = useLocation();
  const { state, dispatch } = useApp();

  const selectedTask = state.selectedTaskId
    ? state.tasks.find((t) => t.id === state.selectedTaskId) || null
    : null;

  useEffect(() => {

  }, [location.pathname]);

  return (
    <AuthInit>
      <>
        <Outlet />
        {selectedTask && (
          <TaskModal
            task={selectedTask}
            onClose={() => dispatch({ type: 'SELECT_TASK', payload: null })}
          />
        )}
        <MasterInit />
      </>
    </AuthInit>
  );
}

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AppProvider>
            <AppContent />
          </AppProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  );
};

export { App };